import { useState } from "react";
import { authAPI } from "../api/api";

function LoginModal({ close, openSignup }) {
  const [form, setForm] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError(""); // Clear error on input change
  };

  const handleLogin = async () => {
    if (!form.email || !form.password) {
      setError("Please fill all fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await authAPI.login(form.email, form.password);

      if (response.success) {
        // Store token and user data
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data));
        
        // Show success message
        const displayName = response.data.role === "partner" 
          ? response.data.owner_name || response.data.business_name 
          : response.data.full_name;
        
        setSuccess(`Login successful! Welcome ${displayName}`);
        
        // Close modal and reload after brief delay
        setTimeout(() => {
          close();
          window.location.reload();
        }, 1000);
      }
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-wrapper">
      <div className="modal-box">
        <span className="close-btn" onClick={close}>✖</span>

        <h2>Login</h2>

        {error && <p style={{ color: '#ff4444', fontSize: '14px', marginTop: '10px' }}>{error}</p>}
        {success && <p style={{ color: '#4CAF50', fontSize: '14px', marginTop: '10px' }}>{success}</p>}

        <input 
          name="email"
          type="email"
          placeholder="Email" 
          value={form.email}
          onChange={handleChange}
          disabled={loading}
        />
        <input 
          name="password"
          type="password" 
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          disabled={loading}
        />

        <button 
          className="top-btn full"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="switch">
          Don't have an account?
          <span onClick={openSignup}> Sign Up</span>
        </p>
      </div>
    </div>
  );
}

export default LoginModal;
